import React from 'react';
import { Search } from "lucide-react";
import { Input } from '@mui/material';

const OrderHeader = ({ onSearchClick }) => {
    return (
        <div className="flex items-center justify-between w-full p-4">
            <div className="mr-24">
                <h3 className="text-[1rem] font-lato font-semibold">Order</h3>
            </div>
            <div className="flex items-center -mr-[15px]">
                <Input
                    readOnly
                    placeholder="Search"
                    endAdornment={<Search sx={{ bottom: "13px", right: "13px", fontSize: "12px" }} />}
                    disableUnderline
                    onClick={onSearchClick}
                    sx={{
                        width: "90%",
                        padding: "10px 13px 10px 30px",
                        backgroundColor: "white",
                        borderRadius: "50px",
                        lineHeight: "18px",
                        height: "25%",
                        fontSize: "12px",
                    }}
                />
            </div>
        </div>
    );
};

export default OrderHeader;